/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {
    RepeatableScreensManagerDeps,
    RepeatableScreensManager
} from '../../../../shared/step/repeatable-screen-manager.class';
import {AoaBoardSubspecialtyService} from '../../../../../domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.service';
import {Screen} from '../../../../../components/sections/service/screen.class';
import {Observable, BehaviorSubject} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {NavigableNode} from '../../../../../components/sections/service/navigable-node.class';

interface Parameters {
    aoaIndex: string;
}

@Injectable()
export class AoaBoardSubspecialtyScreensManager extends RepeatableScreensManager {

    private _aoaIndexSubject$ = new BehaviorSubject<number>(undefined as any);

    get aoaIndex() { return this._aoaIndexSubject$.getValue(); }

    set aoaIndex(value: number) { this._aoaIndexSubject$.next(value); }

    constructor(rsmm: RepeatableScreensManagerDeps, private readonly _aoaSubspecialtyService: AoaBoardSubspecialtyService) {
        super(rsmm);
        this.screenChange$ = this.screenChange$.merge(this._aoaIndexSubject$.distinctUntilChanged().map(() => true)).publishReplay(1).refCount();
    }

    init(parent: NavigableNode<any, any>) {
        super.init(parent);
        merge(this._aoaSubspecialtyService.changes$, this._aoaIndexSubject$.distinctUntilChanged())
            .switchMap(() => this.refresh()).subscribe(() => {});
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        this.aoaIndex = +(route.params as Parameters).aoaIndex;
    }

    navigateToFirstScreenWithAoaIndex(aoaIndex: number): Observable<boolean> {
        this.aoaIndex = aoaIndex;
        return this.refreshed$.filter(value => value).first().flatMap(() => this.navigateToFirstScreen());
    }

    navigateToLastScreenWithAoaIndex(aoaIndex: number): Observable<boolean> {
        this.aoaIndex = aoaIndex;
        return this.refreshed$.filter(value => value).first().flatMap(() => this.navigateToLastScreen());
    }

    protected _navigate(index: number): Observable<boolean> {
        return Observable.fromPromise(this._router.navigateByUrl(this._pathFromRootUsing({
            aoaIndex: this.aoaIndex,
            index: index
        })));
    }

    protected _countEntries(): Observable<number> {
        return this.aoaIndex ? this._aoaSubspecialtyService.countCurrentUserModelEntries(this.aoaIndex) : Observable.of(0);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/aoa-subspecialty/aoa-board-subspecialty-screens-manager.service.ts